import { httpCreate } from './http';

const http = httpCreate('/srv/label');

export const label = {
	getClassification() {
		return http.get('/top');
	},
	getLabelList(parentId, page) {
		return http.get(`/list/${parentId}?pageNum=${page.pageNum}&pageSize=${page.pageSize}`);
	},
	getAllLabelList() {
		return http.get();
	},
	addOtherLabel(params) {
		return http.post('', params);
	},
	modifyLabel(id, data) {
		return http.put(`/title/${id}`, data);
	},
	addTopLabel(params) {
		return http.post('/addTop', params);
	},
	delLabel(id) {
		return http.delete(`/${id}`);
	},
	addActivityLabel(activityId, labelIdList) {
		return http.post(`/activity/${activityId}`, labelIdList);
	},
	getHistoryLabelList() {
		return http.get('/history');
	},
	addRemark(activityId, data) {
		return http.post(`/activity/${activityId}/remark`, data);
	},
	getRemark(activityId) {
		return http.get(`/activity/${activityId}/remark`);
	},
};
